import { apiRequest } from './axiosConfig';

// User-facing video template type (active templates only)
export interface VideoTemplateItem {
  id: number;
  category: string;
  name: string;
  icon?: string;
  description?: string;
  prompt_template: string;
  gradient?: string;
  thumbnail_url?: string | null;
  sample_video_url?: string | null;
  sample_poster_url?: string | null;
  sort_order: number;
}

export interface VideoTemplateCategory {
  category: string;
  count: number;
}

interface VideoTemplatesResponse {
  success: boolean;
  data: VideoTemplateItem[];
}

interface VideoCategoriesResponse {
  success: boolean;
  data: VideoTemplateCategory[];
}

/**
 * User-facing video template API service
 */
const videoTemplateService = {
  /**
   * Get active video templates
   */
  async getTemplates(): Promise<VideoTemplateItem[]> {
    const response = await apiRequest.get<VideoTemplatesResponse>('video-templates');
    return response.data;
  },

  /**
   * Get video template categories
   */
  async getCategories(): Promise<VideoTemplateCategory[]> {
    const response = await apiRequest.get<VideoCategoriesResponse>('video-templates/categories');
    return response.data;
  },
};

export default videoTemplateService;
